function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useQuery from '../../helpers/hooks/useQuery';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Table from '../common/table/Table.react';
var AssetUsage = function AssetUsage() {
  var navigate = useNavigate();
  var _useParams = useParams(),
    contactID = _useParams.id;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useQuery = useQuery({
      api: "".concat(useSelector(function (s) {
        return s.config.endpoints.cms.contacts;
      }), "/usage"),
      params: {
        contactID: contactID
      }
    }),
    response = _useQuery.response;
  useEffect(function () {
    if (!response || !('articles' in response)) return;
    var data = [];
    var articles = response.articles;
    articles.forEach(function (x) {
      data.push({
        _id: x._id,
        slug: x.slug,
        title: x.title,
        app: x.clientApp.join(' ')
      });
    });
    setData(data);
  }, [response]);
  var tableData = {
    data: data,
    columns: {
      _id: {
        title: 'ID',
        visible: false
      },
      slug: {
        title: 'Slug',
        visible: false
      },
      title: 'Title',
      app: {
        title: 'Application',
        size: 'contain'
      }
    },
    tr: {
      onClick: function onClick(row) {
        return navigate("/article/".concat(row._id));
      }
    }
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Usage"
  }), /*#__PURE__*/React.createElement(Table, tableData));
};
export default AssetUsage;